import { useContext } from 'react';

import { LanguageContext } from './context';

export function useTranslation() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within LanguageProvider');
  }
  return context.translations;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return {
    language: context.language,
    setLanguage: context.setLanguage,
    direction: context.direction,
  };
}
